import * as React from "react";

import Modal from "../modal";

interface TimeRangeFilterModalProps {
    header: string;
    show: boolean;
    from: string;
    to: string;
    onClose: (event?) => void;
    onChange: (from, to) => void;
}

export const TimeRangeModal = ({ header, show, onClose, onChange, from, to }: TimeRangeFilterModalProps) => {
    const [currentFrom, setFrom] = React.useState(from ? from : '');
    const [currentTo, setTo] = React.useState(to ? to : '');

    const handleChange = (fromArg, toArg) => {
        onChange(fromArg, toArg);
    };

    const handleClose = (event?) => {
        onClose(event);
        handleChange(currentFrom, currentTo);
    };

    const handleClear = (event?) => {
        setFrom('');
        setTo('');

        onClose(event);
        handleChange('', '');
    };

    return (
        <Modal show={show} closeModalHandler={handleClose} header={header}>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>From</label>
                        <input className="form-control" type="time" step={1} value={currentFrom} onChange={(e) => setFrom(e.target.value)} />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>To</label>
                        <input className="form-control" type="time" step={1} value={currentTo} onChange={(e) => setTo(e.target.value)} />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleClose}>
                    OK
                </button>
                <button className="btn btn-danger" onClick={handleClear}>
                    Clear
                </button>
            </div>
        </Modal>
    );
}
